/* eslint-env browser */
/* global google */
(function () {
  "use strict";

  var DEFAULT_API_BASE = "https://reg.mainstevents.com";
  var AUTOSAVE_DELAY_MS = 2000;
  var FIRST_TOUCH_KEY = "mse_first_touch";
  var CLIENT_ID_KEY = "mse_client_id";
  var CLICK_ID_KEYS = ["gclid", "msclkid", "fbclid", "wbraid", "gbraid", "ttclid"];
  var firstTouchCache = null;
  var lastTouchSnapshot = null;
  var clientIdCache = null;
  var EXTRAS_SOURCE = "shopify_registration_v1";
  var EVENT_ID_KEY_PREFIX = "mse_event_id_";
  // Verification: run document.querySelector(".flair-reg")?.dataset?.apiBase to confirm the configured base URL.

  function safeGetItem(key) {
    try {
      return localStorage.getItem(key);
    } catch (err) {
      return null;
    }
  }

  function safeSetItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (err) {
      /* ignore */
    }
  }

  function safeSessionGetItem(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (err) {
      return null;
    }
  }

  function safeSessionSetItem(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (err) {
      /* ignore */
    }
  }

  function safeSessionRemoveItem(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (err) {
      /* ignore */
    }
  }

  function normalizeEmail(value) {
    if (value == null) return null;
    var trimmed = String(value).trim().toLowerCase();
    return trimmed || null;
  }

  function toNullableString(value) {
    if (value == null) return null;
    var str = String(value).trim();
    return str ? str : null;
  }

  function ensureObject(value) {
    if (!value) return {};
    if (typeof value === "string") {
      try {
        var parsed = JSON.parse(value);
        return ensureObject(parsed);
      } catch (err) {
        return {};
      }
    }
    if (typeof value !== "object" || Array.isArray(value)) return {};
    return value;
  }

  function getQueryParams(search) {
    var params = {};
    var qs = typeof search === "string" ? search : window.location.search;
    if (!qs) return params;
    if (qs.charAt(0) === "?") qs = qs.slice(1);
    if (!qs) return params;
    qs.split("&").forEach(function (pair) {
      if (!pair) return;
      var parts = pair.split("=");
      var key = decodeURIComponent(parts[0] || "").toLowerCase();
      if (!key) return;
      var rawVal = parts[1] || "";
      rawVal = rawVal.replace(/\+/g, " ");
      var value = decodeURIComponent(rawVal);
      params[key] = value;
    });
    return params;
  }

  function readCookie(name) {
    try {
      var match = document.cookie.match(new RegExp("(^|;)\\s*" + name + "=([^;]*)"));
      return match ? decodeURIComponent(match[2]) : "";
    } catch (err) {
      return "";
    }
  }

  function getMetaCookieValues(params) {
    var meta = { fbp: "", fbc: "" };
    var fbp = readCookie("_fbp") || "";
    var fbc = readCookie("_fbc") || "";
    var fbclid = params && params.fbclid ? params.fbclid : "";
    if (!fbc && fbclid) {
      var ts = Math.floor(Date.now() / 1000);
      fbc = "fb.1." + ts + "." + fbclid;
    }
    meta.fbp = fbp;
    meta.fbc = fbc;
    return meta;
  }

  function generateUUID() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    var random = function () {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    };
    return random() + random() + "-" + random() + "-" + random() + "-" + random() + "-" + random() + random() + random();
  }

  function generateEventId() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return "REG-" + Date.now() + "-" + Math.random().toString(16).slice(2);
  }

  function getOrInitEventId(showKey) {
    var key = EVENT_ID_KEY_PREFIX + (showKey || "default");
    try {
      var existing = sessionStorage.getItem(key);
      if (existing) return existing;
      var id = generateEventId();
      sessionStorage.setItem(key, id);
      return id;
    } catch (err) {
      return generateEventId();
    }
  }

  function getDeviceType() {
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0;
    if (width < 768) return "Mobile";
    if (width < 1024) return "Tablet";
    return "Desktop";
  }

  function getTimeZone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    } catch (err) {
      return "";
    }
  }

  function getOrInitClientId() {
    if (clientIdCache) return clientIdCache;
    var existing = safeGetItem(CLIENT_ID_KEY);
    if (existing) {
      clientIdCache = existing;
      return existing;
    }
    var newId = generateUUID();
    clientIdCache = newId;
    safeSetItem(CLIENT_ID_KEY, newId);
    return newId;
  }

  function hostnameFromUrl(url) {
    if (!url) return "";
    try {
      return new URL(url).hostname.toLowerCase();
    } catch (err) {
      return "";
    }
  }

  function deriveTrafficChannel(meta, referrer) {
    var medium = (meta.utm_medium || meta.utmMedium || "").toLowerCase();
    var source = (meta.utm_source || meta.utmSource || "").toLowerCase();
    var refHost = hostnameFromUrl(referrer);
    if (meta.gclid || meta.msclkid || meta.wbraid || meta.gbraid) return "Paid Search";
    if (meta.fbclid) return "Paid Social";
    if (medium.indexOf("email") !== -1) return "Email";
    if (["facebook", "instagram", "meta"].indexOf(source) !== -1 || medium.indexOf("paid_social") !== -1) return "Paid Social";
    if (medium.indexOf("cpc") !== -1 || medium.indexOf("ppc") !== -1) return "Paid Search";

    var organicSearchHosts = ["google.", "bing.", "yahoo.", "duckduckgo.", "baidu.", "yandex.", "ecosia."];
    var organicSocialHosts = [
      "facebook.",
      "l.facebook.",
      "lm.facebook.",
      "m.facebook.",
      "instagram.",
      "t.co",
      "pinterest.",
      "linkedin.",
      "youtube."
    ];
    if (organicSearchHosts.some(function (host) { return refHost.indexOf(host) !== -1; })) return "Organic Search";
    if (organicSocialHosts.some(function (host) { return refHost.indexOf(host) !== -1; })) return "Organic Social";
    var currentHost = hostnameFromUrl(window.location && window.location.href);
    if (refHost && refHost === currentHost) return "Direct";
    if (refHost) return "Referral";
    return "Direct";
  }

  function getOrInitFirstTouch() {
    if (firstTouchCache) return firstTouchCache;
    var stored = safeGetItem(FIRST_TOUCH_KEY);
    if (stored) {
      try {
        firstTouchCache = JSON.parse(stored);
        if (firstTouchCache && typeof firstTouchCache === "object") return firstTouchCache;
      } catch (err) {
        /* ignore parse errors */
      }
    }
    var params = getQueryParams();
    var nowIso = new Date().toISOString();
    var ref = document.referrer || "";
    var metaCookies = getMetaCookieValues(params);
    var firstTouch = {
      landing_page: window.location.href,
      referrer: ref,
      first_touch_at: nowIso,
      device_type: getDeviceType(),
      utm_source: params.utm_source || "",
      utm_medium: params.utm_medium || "",
      utm_campaign: params.utm_campaign || "",
      utm_content: params.utm_content || "",
      utm_term: params.utm_term || "",
      fbp: metaCookies.fbp || "",
      fbc: metaCookies.fbc || "",
      client_id: getOrInitClientId(),
      language: navigator.language || "",
      timezone: getTimeZone()
    };
    var channelMeta = {
      utm_source: firstTouch.utm_source,
      utm_medium: firstTouch.utm_medium
    };
    CLICK_ID_KEYS.forEach(function (key) {
      var val = params[key] || "";
      firstTouch[key] = val;
      channelMeta[key] = val;
    });
    firstTouch.traffic_channel = deriveTrafficChannel(channelMeta, ref);
    safeSetItem(FIRST_TOUCH_KEY, JSON.stringify(firstTouch));
    firstTouchCache = firstTouch;
    return firstTouchCache;
  }

  function buildLastTouch() {
    var params = getQueryParams();
    var ref = document.referrer || "";
    var nowIso = new Date().toISOString();
    var metaCookies = getMetaCookieValues(params);
    var extras = {
      last_touch_at: nowIso,
      last_touch_page: window.location.href,
      last_touch_referrer: ref,
      last_touch_utm_source: params.utm_source || "",
      last_touch_utm_medium: params.utm_medium || "",
      last_touch_utm_campaign: params.utm_campaign || "",
      last_touch_utm_content: params.utm_content || "",
      last_touch_utm_term: params.utm_term || "",
      submission_path: window.location.pathname || "",
      submission_at: nowIso,
      language: navigator.language || "",
      timezone: getTimeZone(),
      last_touch_fbp: metaCookies.fbp || "",
      last_touch_fbc: metaCookies.fbc || ""
    };
    var channelMeta = {
      utm_source: params.utm_source,
      utm_medium: params.utm_medium
    };
    CLICK_ID_KEYS.forEach(function (key) {
      var val = params[key] || "";
      extras["last_touch_" + key] = val;
      channelMeta[key] = val;
    });
    extras.last_touch_channel = deriveTrafficChannel(channelMeta, ref);
    lastTouchSnapshot = extras;
    return extras;
  }

  function normalizeApiBase(base) {
    if (!base) return DEFAULT_API_BASE;
    try {
      var resolved = new URL(base, window.location.origin);
      return (resolved.origin + resolved.pathname).replace(/\/$/, "");
    } catch (err) {
      console.warn("ILOE registration: invalid API base", base, err);
      return DEFAULT_API_BASE;
    }
  }

  function resolveApiBase(root) {
    var base =
      (root && root.dataset && root.dataset.apiBase) ||
      (typeof window !== "undefined" && window.ILOE_API_BASE) ||
      DEFAULT_API_BASE;

    if (window.location.protocol === "https:" && /^http:\/\//i.test(base)) {
      console.warn("ILOE registration: refusing insecure API base on https page", base);
    }
    return normalizeApiBase(base);
  }

  function safeStringify(value) {
    try {
      return JSON.stringify(value);
    } catch (err) {
      return "";
    }
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll(".flair-reg:not([data-initialized])");
    for (var i = 0; i < roots.length; i++) {
      initOne(roots[i]);
      roots[i].setAttribute("data-initialized", "true");
    }
  }

  function initOne(root) {
    var form = root.querySelector("#flairRegForm");
    if (!form) return;

    /* -------- autosave session setup -------- */
    var apiBase = resolveApiBase(root);
    var showCodeEl = form.elements["show_code"];
    var showSlugEl = form.elements["show_slug"];
    var showCode = showCodeEl ? (showCodeEl.value || "").trim() : "";
    var showSlug = showSlugEl ? (showSlugEl.value || "").trim() : "";
    var showKey = showCode || showSlug || "default";
    var storageKey = "iloe_reg_resume_" + showKey;
    var stableEventId = getOrInitEventId(showKey);

    var resumeToken = safeSessionGetItem(storageKey) || null;
    var autosaveArmed = !!resumeToken;
    var autosaveTimer = null;
    var lastAutosaveSignature = "";
    var submitting = false;
    var debugAttribution = false;
    try {
      debugAttribution = new URLSearchParams(window.location.search).get("debug_attribution") === "1";
    } catch (err) {
      debugAttribution = false;
    }
    if (debugAttribution) console.log("[REG] apiBase resolved", apiBase);

    /* -------- original selectors -------- */
    var progressEl = root.querySelector(".flair-reg__progress");
    var rail = root.querySelector(".flair-reg__progress-rail");
    var bar = root.querySelector(".flair-reg__progress-bar");
    var stepLabelEl = root.querySelector(".flair-reg__step-label");
    var steps = Array.prototype.slice.call(root.querySelectorAll(".flair-step"));
    var totalSteps = steps.length;
    var currentStepIndex = 0;

    var attendeesWrap = form.querySelector("[data-attendees]");
    var othersToggle = form.querySelectorAll("input[name='has_others']");
    var othersCountWrap = form.querySelector("[data-others-count]");
    var othersCountEl = form.querySelector("input[name='others_count']");
    var msgEl = root.querySelector("#flairRegMsg");
    var addressInput = form.querySelector("[data-address-autocomplete]");
    var addressHidden = form.querySelector("[data-sync-hidden='address1']");
    var submitBtn = form.querySelector('[type="submit"]');

    /* -------- helpers -------- */
    function setHidden(name, val) {
      var el = form.elements[name];
      if (!el) {
        el = document.createElement("input");
        el.type = "hidden";
        el.name = name;
        form.appendChild(el);
      }
      el.value = val == null ? "" : String(val);
    }

    setHidden("event_id", stableEventId);

    function updateResumeParam(token) {
      try {
        var url = new URL(window.location.href);
        if (token) {
          url.searchParams.set("resume", token);
        } else {
          url.searchParams.delete("resume");
        }
        window.history.replaceState({}, "", url.toString());
      } catch (err) {
        /* ignore */
      }
    }

    function storeResumeToken(token) {
      if (!token) return;
      resumeToken = token;
      autosaveArmed = true;
      safeSessionSetItem(storageKey, token);
      setHidden("resume_token", token);
      updateResumeParam(token);
    }

    function clearResumeToken() {
      resumeToken = null;
      autosaveArmed = false;
      safeSessionRemoveItem(storageKey);
      setHidden("resume_token", "");
      updateResumeParam(null);
    }

    function armAutosave(event) {
      if (autosaveArmed) return;
      if (event && event.isTrusted === false) return;
      autosaveArmed = true;
    }

    function captureUTM() {
      firstTouchCache = getOrInitFirstTouch();
      var ft = firstTouchCache || {};
      ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(function (k) {
        setHidden(k, ft[k] || "");
      });
      setHidden("landing_page", ft.landing_page || window.location.href);
      setHidden("referrer", ft.referrer || "");
      setHidden("traffic_channel", ft.traffic_channel || deriveTrafficChannel(ft, ft.referrer || ""));
      setHidden("first_touch_at", ft.first_touch_at || "");
      setHidden("device_type", ft.device_type || getDeviceType());
      setHidden("client_id", ft.client_id || getOrInitClientId());
      setHidden("event_id", stableEventId);
      setHidden("fbp", ft.fbp || "");
      setHidden("fbc", ft.fbc || "");
      CLICK_ID_KEYS.forEach(function (key) {
        setHidden(key, ft[key] || "");
      });
    }

    function ensureSession() {
      var t = safeGetItem("iloe_reg_session");
      if (!t) {
        t = window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now() + "-" + Math.random();
        safeSetItem("iloe_reg_session", t);
      }
      setHidden("session_token", t);
      return t;
    }

    function syncAddressHidden() {
      if (addressInput && addressHidden) addressHidden.value = addressInput.value || "";
    }

    if (addressInput) {
      addressInput.addEventListener("input", syncAddressHidden);
      addressInput.addEventListener("change", syncAddressHidden);
      addressInput.style.setProperty("-webkit-text-security", "none", "important");
      addressInput.style.setProperty("text-security", "none", "important");
    }

    var textSecurityGuard = setInterval(function () {
      if (!document.body.contains(root)) {
        clearInterval(textSecurityGuard);
        return;
      }
      if (addressInput) {
        addressInput.style.setProperty("-webkit-text-security", "none", "important");
        addressInput.style.setProperty("text-security", "none", "important");
      }
    }, 800);

    var titles = [
      "Register Your Store",
      "Store Address",
      "Tell Us About Your Store",
      "Register Additional Team Members",
      "Registration Complete"
    ];

    function setProgress() {
      var frac = totalSteps ? (currentStepIndex + 1) / totalSteps : 0;
      var pctValue = Math.max(0, Math.min(100, frac * 100));
      var pctString = pctValue + "%";

      if (rail) {
        rail.style.setProperty("--p", String(frac));
        rail.style.setProperty("--progress", pctString);
        rail.setAttribute("data-progress-frac", String(frac));
      }
      if (bar) {
        bar.style.setProperty("--p", String(frac));
        bar.style.setProperty("--progress", pctString);
        bar.style.width = pctString;
      }
      if (progressEl) progressEl.setAttribute("aria-valuenow", String(Math.round(pctValue)));
      if (stepLabelEl) {
        stepLabelEl.innerHTML =
          "Step <strong>" + (currentStepIndex + 1) + "</strong> of <strong>" + totalSteps + "</strong> — " + (titles[currentStepIndex] || "");
      }
    }

    function scrollStepIntoView() {
      var progressRect = root.querySelector(".flair-reg__progress");
      var scrollOffset = 60;
      var targetElement = progressRect || steps[currentStepIndex];
      var targetRect = targetElement.getBoundingClientRect();
      var targetTop = targetRect.top + window.pageYOffset - scrollOffset;
      var scrollOptions = { top: Math.max(0, targetTop), behavior: "smooth" };
      try {
        window.scrollTo(scrollOptions);
      } catch (_) {
        window.scrollTo(0, Math.max(0, targetTop));
      }
    }

    function focusFirstField() {
      var focusables = steps[currentStepIndex].querySelectorAll("input:not([type='hidden']), textarea, select, button");
      var first = null;
      for (var f = 0; f < focusables.length; f++) {
        var el = focusables[f];
        if (el.disabled) continue;
        if (el.tagName === "SELECT") continue;
        first = el;
        break;
      }
      if (!first && focusables.length) first = focusables[0];
      if (first && typeof first.focus === "function") {
        try {
          first.focus({ preventScroll: true });
        } catch (e) {
          first.focus();
        }
      }
    }

    function showStep(index) {
      var idx = Math.max(0, Math.min(index, totalSteps - 1));
      for (var s = 0; s < steps.length; s++) steps[s].hidden = s !== idx;
      currentStepIndex = idx;
      setProgress();
      scrollStepIntoView();
      focusFirstField();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        // Tracking only — safe rename; backend unaffected.
        event: "iloe_retail_registration_step",
        step: currentStepIndex + 1,
        event_id: stableEventId,
        program: "ILOE",
        registration_type: "retailer"
      });

      scrubTextSecurity(root);
      syncAddressHidden();
      scheduleAutosave("step");
    }

    function validateStep(index) {
      var fs = steps[index];
      var required = fs.querySelectorAll("[required]");
      for (var i = 0; i < required.length; i++) {
        var el = required[i];
        var bad = !el.value || (el.type === "email" && !/\S+@\S+\.\S+/.test(el.value));
        if (bad) {
          el.focus();
          el.setAttribute("aria-invalid", "true");
          if (msgEl) msgEl.textContent = "Please complete the required fields.";
          return false;
        } else {
          el.removeAttribute("aria-invalid");
        }
      }
      if (msgEl) msgEl.textContent = "";
      return true;
    }

    function hasOthersYes() {
      var yesRadio = form.querySelector("input[name='has_others'][value='Yes']");
      return !!(yesRadio && yesRadio.checked);
    }

    function toggleOthersCount() {
      if (!othersCountWrap) return;
      var show = hasOthersYes();
      othersCountWrap.hidden = !show;
      othersCountWrap.setAttribute("aria-hidden", show ? "false" : "true");
      if (othersCountWrap.classList) othersCountWrap.classList.toggle("is-hidden", !show);
      if (!show && othersCountEl) othersCountEl.value = "0";
    }

    function renderAttendees() {
      if (!attendeesWrap) return;
      var n = 0;
      if (hasOthersYes() && othersCountEl) {
        var v = parseInt(othersCountEl.value || "0", 10);
        if (!isNaN(v)) n = Math.min(10, Math.max(0, v));
      }
      attendeesWrap.innerHTML = "";
      for (var i = 1; i <= n; i++) {
        var firstId = "attendee-" + i + "-first";
        var lastId = "attendee-" + i + "-last";
        var emailId = "attendee-" + i + "-email";

        var block = document.createElement("div");
        block.className = "attendee-block";
        block.setAttribute("data-guest-index", String(i));

        block.innerHTML =
          '<div class="f-grid">' +
          '<label class="f-field">' +
          "<span>First name</span>" +
          '<input id="' + firstId + '" name="attendee_' + i + '_first" placeholder="First name">' +
          "</label>" +
          '<label class="f-field">' +
          "<span>Last name</span>" +
          '<input id="' + lastId + '" name="attendee_' + i + '_last" placeholder="Last name">' +
          "</label>" +
          '<label class="f-field">' +
          "<span>Email</span>" +
          '<input id="' + emailId + '" name="attendee_' + i + '_email" type="email" inputmode="email" placeholder="email@domain.com">' +
          "</label>" +
          "</div>";

        attendeesWrap.appendChild(block);
      }
    }

    function getParam(name) {
      var m = new RegExp("[?&]" + name + "=([^&]+)").exec(window.location.search);
      return m ? decodeURIComponent(m[1].replace(/\+/g, " ")) : null;
    }

    function setField(name, val) {
      var el = form.elements[name];
      if (!el) return;
      if (el instanceof RadioNodeList) {
        var list = Array.prototype.slice.call(form.querySelectorAll('[name="' + name + '"]'));
        list.forEach(function (n) {
          if (n.type === "checkbox") {
            if (Array.isArray(val)) n.checked = val.indexOf(n.value) !== -1;
          } else if (n.type === "radio") {
            n.checked = String(n.value) === String(val);
          }
        });
        return;
      }
      if (el.tagName === "SELECT") el.value = val != null ? val : "";
      else if (el.type === "checkbox") el.checked = !!val;
      else el.value = val != null ? val : "";
    }

    function hydrateFromDraft(draft) {
      if (!draft) return;
      var payload = draft.payload || {};
      [
        "company",
        "email",
        "first_name",
        "last_name",
        "phone",
        "address1",
        "address2",
        "city",
        "region",
        "postal_code",
        "country",
        "store_phone",
        "store_category",
        "show_code",
        "show_slug",
        "others_count",
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_term"
      ].forEach(function (k) {
        if (payload[k] != null) setField(k, payload[k]);
      });

      if (Array.isArray(payload.categories)) {
        var boxes = form.querySelectorAll('input[name="categories[]"]');
        boxes.forEach(function (b) {
          b.checked = payload.categories.indexOf(b.value) !== -1;
        });
      }

      if (payload.has_others === "Yes" || payload.has_others === "No") {
        setField("has_others", payload.has_others);
      }

      if (Array.isArray(payload.guests) && payload.guests.length) {
        var guests = payload.guests;
        var n = Math.min(10, guests.length);
        setField("others_count", String(n));
        toggleOthersCount();
        renderAttendees();
        for (var i = 0; i < n; i++) {
          var g = guests[i] || {};
          var idx = g.guest_index || i + 1;
          var f = form.elements["attendee_" + idx + "_first"];
          var l = form.elements["attendee_" + idx + "_last"];
          var e = form.elements["attendee_" + idx + "_email"];
          if (f) f.value = g.first_name || "";
          if (l) l.value = g.last_name || "";
          if (e) e.value = g.email || "";
        }
      }

      var disp = form.querySelector('[name="address1_display"]');
      if (disp && !disp.value && payload.address1) disp.value = payload.address1;
      syncAddressHidden();

      var stepIndex = typeof draft.step_index === "number" ? draft.step_index : 0;
      stepIndex = Math.max(0, Math.min(stepIndex, steps.length - 1));
      showStep(stepIndex);

      if (msgEl) msgEl.textContent = "We restored your saved progress.";
    }

    function scrubTextSecurity(scope) {
      if (!scope) return;
      var fields = scope.querySelectorAll(".f-field input, .f-field textarea");
      for (var i = 0; i < fields.length; i++) {
        try {
          fields[i].style.setProperty("-webkit-text-security", "none", "important");
          fields[i].style.setProperty("text-security", "none", "important");
        } catch (err) {
          /* no-op */
        }
      }
    }

    function waitForPlaces(cb) {
      var tries = 0;
      var iv = setInterval(function () {
        if (window.google && google.maps && google.maps.places) {
          clearInterval(iv);
          cb();
          return;
        }
        if (++tries > 100) clearInterval(iv);
      }, 100);
    }

    function attachPlaces() {
      if (!addressInput) return;
      var ac = new google.maps.places.Autocomplete(addressInput, {
        types: ["address"],
        fields: ["address_components", "formatted_address", "geometry"]
      });

      ac.addListener("place_changed", function () {
        var place = ac.getPlace();
        if (!place || !place.address_components) return;

        function part(type) {
          var comps = place.address_components || [];
          for (var i = 0; i < comps.length; i++) {
            if (comps[i].types && comps[i].types.indexOf(type) !== -1) {
              return comps[i].long_name || "";
            }
          }
          return "";
        }

        var streetNumber = part("street_number");
        var route = part("route");
        var address1 = (streetNumber ? streetNumber + " " : "") + (route || "");
        if (address1) addressInput.value = address1;
        syncAddressHidden();

        var cityEl = form.elements["city"];
        var regionEl = form.elements["region"];
        var zipEl = form.elements["postal_code"];
        var countryEl = form.elements["country"];

        if (cityEl) cityEl.value = part("locality") || part("sublocality") || part("postal_town") || "";
        if (regionEl) regionEl.value = part("administrative_area_level_1") || "";
        if (zipEl) zipEl.value = part("postal_code") || "";
        if (countryEl) countryEl.value = part("country") || "";
      });
    }

    /* -------- autosave helpers -------- */
    function serializePayload(options) {
      var forSubmit = !!(options && options.forSubmit);
      syncAddressHidden();

      var fd = new FormData(form);
      var payload = {};
      fd.forEach(function (value, key) {
        if (key === "categories[]") return;
        if (payload[key] !== undefined) {
          if (!Array.isArray(payload[key])) payload[key] = [payload[key]];
          payload[key].push(value);
        } else {
          payload[key] = value;
        }
      });

      var categories = fd
        .getAll("categories[]")
        .map(function (v) {
          return (v || "").toString().trim();
        })
        .filter(Boolean);
      if (categories.length) payload.categories = categories;

      var count = parseInt(payload.others_count || "0", 10);
      if (isNaN(count)) count = 0;
      count = Math.max(0, Math.min(count, 10));

      var guests = [];
      for (var i = 1; i <= count; i++) {
        var f = (payload["attendee_" + i + "_first"] || "").trim();
        var l = (payload["attendee_" + i + "_last"] || "").trim();
        var e = (payload["attendee_" + i + "_email"] || "").trim();
        var normalizedGuestEmail = normalizeEmail(e);
        if (f || l || e) {
          guests.push({ first_name: f || null, last_name: l || null, email: normalizedGuestEmail || null, guest_index: i });
        }
        delete payload["attendee_" + i + "_first"];
        delete payload["attendee_" + i + "_last"];
        delete payload["attendee_" + i + "_email"];
      }
      if (guests.length) payload.guests = guests;
      else delete payload.guests;

      payload.address1 = payload.address1 || payload.address1_display || "";
      delete payload.address1_display;

      payload.show_code = payload.show_code || showCode;
      if (!payload.show_slug && showSlug) payload.show_slug = showSlug;
      if (resumeToken) payload.resume_token = resumeToken;
      if (!payload.event_id) payload.event_id = stableEventId;
      var normalizedEmail = normalizeEmail(payload.email);
      payload.email = normalizedEmail || null;

      var firstTouch = getOrInitFirstTouch() || {};
      payload.landing_page = payload.landing_page || firstTouch.landing_page || window.location.href;
      payload.referrer = payload.referrer || firstTouch.referrer || "";
      payload.traffic_channel = payload.traffic_channel || firstTouch.traffic_channel || deriveTrafficChannel(firstTouch, firstTouch.referrer || "");
      payload.first_touch_at = firstTouch.first_touch_at || payload.first_touch_at || "";
      payload.device_type = firstTouch.device_type || payload.device_type || getDeviceType();
      payload.utm_source = toNullableString(payload.utm_source || firstTouch.utm_source);
      payload.utm_medium = toNullableString(payload.utm_medium || firstTouch.utm_medium);
      payload.utm_campaign = toNullableString(payload.utm_campaign || firstTouch.utm_campaign);
      payload.utm_content = toNullableString(payload.utm_content || firstTouch.utm_content);
      payload.utm_term = toNullableString(payload.utm_term || firstTouch.utm_term);
      payload.client_id = firstTouch.client_id || payload.client_id || getOrInitClientId();
      var currentMeta = getMetaCookieValues(getQueryParams());
      payload.fbp = currentMeta.fbp || payload.fbp || firstTouch.fbp || null;
      payload.fbc = currentMeta.fbc || payload.fbc || firstTouch.fbc || null;
      CLICK_ID_KEYS.forEach(function (key) {
        if (!payload[key]) payload[key] = firstTouch[key] || "";
      });

      var utmObj = {
        utm_source: payload.utm_source,
        utm_medium: payload.utm_medium,
        utm_campaign: payload.utm_campaign,
        utm_content: payload.utm_content,
        utm_term: payload.utm_term
      };
      CLICK_ID_KEYS.forEach(function (key) {
        utmObj[key] = toNullableString(payload[key] || firstTouch[key]);
      });
      payload.utm = utmObj;

      var lastTouch = buildLastTouch();
      var extrasBase = ensureObject(payload.extras);
      var extras = Object.assign({}, extrasBase, lastTouch, {
        source: EXTRAS_SOURCE,
        landing_page: payload.landing_page || firstTouch.landing_page || window.location.href,
        referrer: toNullableString(payload.referrer || firstTouch.referrer),
        traffic_channel: payload.traffic_channel || firstTouch.traffic_channel || deriveTrafficChannel(firstTouch, firstTouch.referrer || ""),
        client_id: payload.client_id || firstTouch.client_id || getOrInitClientId(),
        session_token: payload.session_token || null,
        event_id: payload.event_id || stableEventId || null,
        fbp: payload.fbp || null,
        fbc: payload.fbc || null,
        first_touch_at: firstTouch.first_touch_at || null,
        utm_source: payload.utm_source || null,
        utm_medium: payload.utm_medium || null,
        utm_campaign: payload.utm_campaign || null,
        utm_content: payload.utm_content || null,
        utm_term: payload.utm_term || null
      });
      CLICK_ID_KEYS.forEach(function (key) {
        extras[key] = payload[key] || firstTouch[key] || null;
      });
      payload.extras = extras;

      if (forSubmit) {
        payload.submission_page = window.location.href;
        payload.extras.last_touch_at = payload.extras.last_touch_at || lastTouch.last_touch_at || new Date().toISOString();
      }

      return payload;
    }

    function currentProgressFraction() {
      if (!totalSteps) return null;
      return Math.max(0, Math.min(1, (currentStepIndex + 1) / totalSteps));
    }

    function scheduleAutosave(reason) {
      if (submitting || !autosaveArmed) return;
      clearTimeout(autosaveTimer);
      autosaveTimer = setTimeout(function () {
        autosaveNow(reason);
      }, AUTOSAVE_DELAY_MS);
    }

    function autosaveNow(reason) {
      var payload = serializePayload({ forSubmit: false });
      var signature = safeStringify({ payload: payload, step_index: currentStepIndex });
      if (signature && signature === lastAutosaveSignature) return;
      lastAutosaveSignature = signature;

      var body = {
        show_code: payload.show_code || payload.show_slug || "",
        email: payload.email || null,
        step: currentStepIndex + 1,
        progress: currentProgressFraction(),
        event_id: payload.event_id || stableEventId || null,
        resume_token: resumeToken,
        guest_count: Array.isArray(payload.guests) ? payload.guests.length : null,
        utm: payload.utm || null,
        extras: payload.extras || null,
        data: {
          payload: payload,
          step_index: currentStepIndex,
          reason: reason || null
        }
      };

      if (!body.show_code) return;

      fetch(apiBase + "/api/registration-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().catch(function () {
            return {};
          });
        })
        .then(function (json) {
          if (json && json.ok && json.resume_token) storeResumeToken(json.resume_token);
        })
        .catch(function (err) {
          console.warn("ILOE autosave failed", err);
        });
    }

    function normalizeDraftData(session) {
      if (!session) return null;
      var raw = session.data || session;
      if (typeof raw === "string") {
        try {
          raw = JSON.parse(raw);
        } catch (err) {
          raw = null;
        }
      }
      if (!raw || typeof raw !== "object") return null;
      if (raw.payload) return raw;
      return { payload: raw, step_index: raw.step_index || 0 };
    }

    function loadDraft(token) {
      if (!token) return Promise.resolve();
      return fetch(apiBase + "/api/registration-session?token=" + encodeURIComponent(token), {
        method: "GET",
        headers: { Accept: "application/json" }
      })
        .then(function (res) {
          return res.json().catch(function () {
            return {};
          });
        })
        .then(function (json) {
          if (!json || !json.ok || !json.session) return;
          storeResumeToken(json.session.resume_token || token);
          var draft = normalizeDraftData(json.session);
          hydrateFromDraft(draft);
          lastAutosaveSignature = "";
          scheduleAutosave("hydrate");
        })
        .catch(function (err) {
          console.warn("ILOE resume load failed", err);
        });
    }

    function finalizeSession() {
      if (!resumeToken) return Promise.resolve();
      return fetch(apiBase + "/api/registration-session/" + encodeURIComponent(resumeToken) + "/finalize", {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      }).catch(function (err) {
        console.warn("ILOE finalize failed", err);
      });
    }

    /* -------- events -------- */
    form.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" || e.defaultPrevented) return;
      var target = e.target;
      if (!target) return;
      var tag = target.tagName;
      if (tag === "TEXTAREA" || target.isContentEditable) return;
      if (tag === "BUTTON") return;
      if (tag === "INPUT") {
        var type = (target.type || "").toLowerCase();
        if (type === "submit" || type === "button") return;
      }
      if (currentStepIndex < totalSteps - 1) {
        e.preventDefault();
        if (!validateStep(currentStepIndex)) return;
        showStep(currentStepIndex + 1);
      }
    });

    form.addEventListener("click", function (e) {
      var next = e.target.closest && e.target.closest("[data-next]");
      var prev = e.target.closest && e.target.closest("[data-prev]");
      if (next) {
        if (!validateStep(currentStepIndex)) return;
        if (currentStepIndex === 0) {
          var nowIso = new Date().toISOString();
          var mo = form.elements["marketing_opt_in"];
          var cv = form.elements["consent_version"];
          var ca = form.elements["consented_at"];
          if (mo) mo.value = "true";
          if (cv && !cv.value) cv.value = "iloe-reg-v1";
          if (ca) ca.value = nowIso;
        }
        if (currentStepIndex < totalSteps - 1) showStep(currentStepIndex + 1);
      }
      if (prev) {
        if (currentStepIndex > 0) showStep(currentStepIndex - 1);
      }
    });

    for (var r = 0; r < othersToggle.length; r++) {
      othersToggle[r].addEventListener("change", function (event) {
        armAutosave(event);
        toggleOthersCount();
        if (hasOthersYes()) renderAttendees();
        else if (attendeesWrap) attendeesWrap.innerHTML = "";
        scheduleAutosave("toggle_guests");
      });
    }

    if (othersCountEl) {
      othersCountEl.addEventListener("input", function (event) {
        armAutosave(event);
        renderAttendees();
        scheduleAutosave("guest_count");
      });
    }

    form.addEventListener("input", function (event) {
      armAutosave(event);
      scheduleAutosave("input");
    });

    form.addEventListener("change", function (event) {
      armAutosave(event);
      scheduleAutosave("change");
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!validateStep(currentStepIndex)) return;

      submitting = true;
      clearTimeout(autosaveTimer);

      var payload = serializePayload({ forSubmit: true });
      var submitEventId = stableEventId;
      payload.event_id = submitEventId;
      setHidden("event_id", submitEventId);
      var params = new URLSearchParams(location.search);
      if (!payload.show_code) {
        payload.show_code = params.get("show") || showCode || showSlug || "";
      }
      if (!payload.show_code && !payload.show_slug) {
        if (msgEl) msgEl.textContent = "Missing show code — configure it in the section settings.";
        submitting = false;
        return;
      }
      if (resumeToken) payload.resume_token = resumeToken;

      if (debugAttribution) {
        console.log("[ILOE] first_touch", firstTouchCache || getOrInitFirstTouch());
        console.log("[ILOE] last_touch", lastTouchSnapshot || {});
        console.log("[ILOE] payload", payload);
      }

      if (submitBtn) submitBtn.disabled = true;

      fetch(apiBase + "/api/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().catch(function () {
            return {};
          });
        })
        .then(function (body) {
          if (!body || body.ok === false) {
            var errMsg = body && body.error ? body.error : "Registration failed";
            var stepMsg = body && body.step ? " [" + body.step + "]" : "";
            if (msgEl) msgEl.textContent = "Registration failed: " + errMsg + stepMsg;
            throw new Error(errMsg);
          }

          if (debugAttribution) console.log("DEBUG ILOE: success handler reached", { payload: payload });

          // ----- Tracking: completed registration -----
          var showCodeForTracking = payload.show_code || payload.show_slug || "";
          var registrationId =
            body.registration_id ||
            body.id ||
            (body.data && (body.data.registration_id || body.data.id)) ||
            (body.registration && (body.registration.registration_id || body.registration.id)) ||
            null;
          var firedKey = "iloe_retail_registration_success_" + (registrationId || stableEventId);
          try {
            if (sessionStorage.getItem(firedKey) === "1") return finalizeSession();
            sessionStorage.setItem(firedKey, "1");
          } catch (e) {
            /* ignore */
          }
          var program = "ILOE";
          var registration_type = "retailer";
          var userData = {
            email: normalizeEmail(payload.email),
            phone: toNullableString(payload.phone),
            first_name: toNullableString(payload.first_name),
            last_name: toNullableString(payload.last_name),
            city: toNullableString(payload.city),
            region: toNullableString(payload.region),
            postal_code: toNullableString(payload.postal_code),
            country: toNullableString(payload.country)
          };

          // 1) Dedicated complete-registration event with rich data
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            // Tracking only — safe rename; backend unaffected.
            event: "iloe_retail_registration_success",
            event_id: submitEventId,
            registration_id: registrationId,
            program: program,
            registration_type: registration_type,
            show_code: showCodeForTracking,
            page_path: window.location.pathname,
            traffic_channel: payload.traffic_channel || null,
            utm_source: payload.utm_source || null,
            utm_medium: payload.utm_medium || null,
            utm_campaign: payload.utm_campaign || null,
            utm_content: payload.utm_content || null,
            utm_term: payload.utm_term || null,
            fbp: payload.fbp || null,
            fbc: payload.fbc || null,
            client_id: payload.client_id || null,
            session_token: payload.session_token || null,
            user_data: userData
          });

          // 2) Generic submit event (same event_id, no PII at top level)
          window.dataLayer.push({
            // Tracking only — safe rename; backend unaffected.
            event: "iloe_retail_registration_submit",
            event_id: submitEventId,
            lead_type: "buyer_registration",
            lead_origin: "shopify_registration_section",
            show_code: showCodeForTracking,
            registration_id: registrationId,
            program: program,
            registration_type: registration_type
          });

          // ----- Existing UX behavior -----
          if (msgEl) msgEl.textContent = "";
          if (root) root.setAttribute("data-complete", "true");
          showStep(totalSteps - 1);
          clearResumeToken();
          lastAutosaveSignature = "";
          return finalizeSession();
        })
        .catch(function (err) {
          if (!msgEl.textContent) msgEl.textContent = "Network error submitting registration.";
          console.error(err);
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
          submitting = false;
        });
    });

    /* -------- init -------- */
    captureUTM();
    ensureSession();
    scrubTextSecurity(root);
    toggleOthersCount();
    renderAttendees();
    syncAddressHidden();

    var resumeParam = getParam("resume");
    if (resumeParam) storeResumeToken(resumeParam);
    else if (resumeToken) setHidden("resume_token", resumeToken);

    if (resumeToken) {
      loadDraft(resumeToken).finally(function () {
        if (!resumeToken) showStep(0);
      });
    } else {
      showStep(0);
    }

    if (addressInput) waitForPlaces(attachPlaces);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    boot(e.target);
  });
})();
